module.exports = __webpack_public_path__ + "aeb620af5bdcdcc631b0e7836bb8d456.jpg";